// import firebase from "firebase/app";
// import "firebase/app";
// import "firebase/auth";
// import "firebase/firestore";
// import store from "./../store";
// import { DetectBrand } from "../mixins/brandDetector";
// import { AppConfig } from "../../AppConfig";
// var brandedConfig = {
//   apiKey: "AIzaSyAtHqepcIJdj3pTaC0eyeK09wexEIxW5K4",
//   authDomain: "abacusoo-sushi-hub.firebaseapp.com",
//   databaseURL: "https://abacusoo-sushi-hub.firebaseio.com",
//   projectId: "abacusoo-sushi-hub",
//   storageBucket: "abacusoo-sushi-hub.appspot.com",
//   messagingSenderId: "1087170880950",
// };
// var generalConfig = {
//   apiKey: "AIzaSyAMhuFsddO482nDpQp-jr6tUwyw-mjG6Us",
//   authDomain: "abacus-company-project.firebaseapp.com",
//   databaseURL: "https://abacus-company-project.firebaseio.com",
//   projectId: "abacus-company-project",
//   storageBucket: "abacus-company-project.appspot.com",
//   messagingSenderId: "799769146157",
//   appId: "1:799769146157:web:d497b21a3e793a5c",
// };
// var releaseConfig = {
//   apiKey: AppConfig.firebaseApiKey,
//   authDomain: AppConfig.firebaseProjectId + ".firebaseapp.com",
//   databaseURL: AppConfig.firebaseProjectId + ".firebaseio.com",
//   projectId: AppConfig.firebaseProjectId,
//   storageBucket: AppConfig.firebaseProjectId + ".appspot.com",
//   messagingSenderId: AppConfig.firebaseMessagingSenderId,
// };
// console.log("stuff ", process.env.NODE_ENV === "development"
//     ? releaseConfig
//     : DetectBrand.methods.isBranded()
//         ? brandedConfig
//         : generalConfig)
// firebase.initializeApp(
//     brandedConfig
// );
//
// /*
//   setLogLevel param:
// - debug for the most verbose logging level, primarily for debugging.
// - error to log errors only.
// - silent to turn off logging.
// */
// firebase.firestore.setLogLevel("silent");
// export const db = firebase.firestore();
// export const auth = firebase.auth();
// auth.onAuthStateChanged((user) => {
//   if (user) {
//     store.dispatch("autoSignIn", user);
//   }
// });

import firebase from "firebase/app";
import "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import store from "./../store";
import { DetectBrand } from "../mixins/brandDetector";
import { AppConfig } from "../../AppConfig";
var brandedConfig = {
  apiKey: "AIzaSyCGhJa8iZM_JU3UvEQ37gz5qOrQbwOdcEQ",
  authDomain: "abacus-online-ordering-test.firebaseapp.com",
  databaseURL: "https://abacus-online-ordering-test.firebaseio.com",
  projectId: "abacus-online-ordering-test",
  storageBucket: "abacus-online-ordering-test.appspot.com",
  messagingSenderId: "1087170880950",
};
var generalConfig = {
  apiKey: "AIzaSyAMhuFsddO482nDpQp-jr6tUwyw-mjG6Us",
  authDomain: "abacus-company-project.firebaseapp.com",
  databaseURL: "https://abacus-company-project.firebaseio.com",
  projectId: "abacus-company-project",
  storageBucket: "abacus-company-project.appspot.com",
  messagingSenderId: "799769146157",
  appId: "1:799769146157:web:d497b21a3e793a5c",
};
var releaseConfig = {
  apiKey: AppConfig.firebaseApiKey,
  authDomain: AppConfig.firebaseProjectId + ".firebaseapp.com",
  databaseURL: AppConfig.firebaseProjectId + ".firebaseio.com",
  projectId: AppConfig.firebaseProjectId,
  storageBucket: AppConfig.firebaseProjectId + ".appspot.com",
  messagingSenderId: AppConfig.firebaseMessagingSenderId,
};
firebase.initializeApp(
    process.env.NODE_ENV === "production"
        ? releaseConfig
        : DetectBrand.methods.isBranded()
            ? brandedConfig
            : generalConfig
);

/*
  setLogLevel param:
- debug for the most verbose logging level, primarily for debugging.
- error to log errors only.
- silent to turn off logging.
*/
firebase.firestore.setLogLevel("silent");
export const db = firebase.firestore();
export const auth = firebase.auth();
export const rtdb = firebase.database();
auth.onAuthStateChanged((user) => {
  if (user) {
    store.dispatch("autoSignIn", user);
  }
});

